import { LatLon } from "geolocation-utils";
import { httpsCallable } from "firebase/functions";

import { functions } from "configs";
import { FUNCTIONS } from "constants/firebase";
import { FirebaseBoundary, Iterable, IMember } from "types";

type DefaultHTTPSResponse = { message: string };

export const packCirclesIn = (countryCode: string) => {
  const callable = httpsCallable<
    { countryCode: string },
    { circles: LatLon[][]; boundaries: Iterable<FirebaseBoundary> }
  >(functions, FUNCTIONS.PACK_CIRCLES_IN);
  return callable({ countryCode });
};

type InitQuery = {
  countryCode: string;
  tag: string;
};

export const initPlacesParsing = (props: InitQuery) => {
  const callable = httpsCallable<InitQuery, DefaultHTTPSResponse>(
    functions,
    FUNCTIONS.INIT_PLACES_PARSING
  );
  return callable(props);
};

export const test = () => {
  const callable = httpsCallable(functions, "testAvailability", {
    timeout: 540000,
  });
  return callable();
};

export const uploadDumpToDb = (stringifiedJson: string) => {
  const callable = httpsCallable(functions, FUNCTIONS.UPLOAD_TO_DUMP, {
    timeout: 540000,
  });
  return callable({ places: stringifiedJson });
};

export const authMember = (email: string) => {
  const callable = httpsCallable<{ email: string }, { member: IMember }>(
    functions,
    FUNCTIONS.AUTH_MEMBER
  );
  return callable({ email });
};
